import { Notificacion } from "@components/general/Alertas/Alertas";
import { deletePublicacion } from "@helpers/httpRequests/httpRequestsForoEmpresarial/httpRequestsForoEmpresarial";
import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const EliminarPublicacion = ({ setPublicacionEliminada, publicacion }) => {

  const {t} = useTranslation();

  const { idPublicacion } = publicacion;
  // console.log(idPublicacion);

  const cancelarDeshabilitarPublicacion = () => {
    Notificacion("info", t('businessForum.noDeactivated'));
  };

  const deshabilitarPublicacion = async () => {
    try {
      const { message, data } = await deletePublicacion(idPublicacion);
      // console.log(data);
      setPublicacionEliminada(true);
      Notificacion("success", t('businessForum.postDeactivated'));
    } catch (error) {
      Notificacion("error", "Error al deshabilitar la publicación");
    }
  };

  return (
    <Container fluid className="text-center">
      <h3>{t('businessForum.deactivatePostConfirmation')}</h3>

      <Row className="pt-3">
        <Col>
          <Button variant="success" onClick={deshabilitarPublicacion}>
            {t('businessForum.confirmDeactivatePost')}
          </Button>
        </Col>

        <Col>
          <Button variant="danger" onClick={cancelarDeshabilitarPublicacion}>
            {t('businessForum.cancelDeactivatePost')}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default EliminarPublicacion;
